module.exports = __webpack_public_path__ + "res/ic_delete.41b0ea4e19ce85866d51bed57465db27.png";